import React, { Fragment } from 'react';
import {
  Card,
  CardActions,
  IconButton,
  Typography,
  CardMedia,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
import { FileUpload } from './FileUpload';
import { uploadImageAllowedTypes } from '../../../utils';

const ImagePreviewContainer = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const ImageCard = styled(Card)({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '&:hover .delete-button': {
    opacity: 1,
  },
});

const DeleteButton = styled(IconButton)({
  position: 'absolute',
  top: '5px',
  right: '5px',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  opacity: 0,
  transition: 'opacity 0.3s',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
});

const CaseLogo = ({ onFileChange, onDeleteImage, selectedImage = {} }) => {
  const handleFileChange = (e) => {
   // onFileChange(e);
   const file = e.target.files[0];

  if (file) {
    onFileChange({
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
    });
  }
  };

  const handleDeleteClick = (imageId) => {
    if (onDeleteImage) {
      onDeleteImage(imageId);
    }
  };

  return (
    <Fragment>
      {!selectedImage ? (
        <FileUpload
          allowedExtensions={uploadImageAllowedTypes}
          allowMultipleFiles={false}
          name="signatureImage"
          onChange={handleFileChange}
          placeholder="Učitaj sliku potpisa"
        />
      ) : (
        <ImagePreviewContainer>
          <ImageCard key={selectedImage.id}>
            <CardMedia
              component="img"
              height="100"
              image={selectedImage.preview}
              alt={selectedImage.name}
             sx={{
                objectFit: 'cover',
                width: '100%',
                height: 'calc(100% - 40px)',
                cursor: 'pointer'
              }}
              onClick={handleFileChange} 
            />
            <DeleteButton
              className="delete-button"
              size="small"
              onClick={handleDeleteClick}
              title="Delete image"
            >
              <DeleteIcon fontSize="small" />
            </DeleteButton>
            <CardActions sx={{ 
              padding: '8px',
              minHeight: '40px',
              backgroundColor: 'rgba(0,0,0,0.05)',
              justifyContent: 'center'
            }}>
              <Typography 
                variant="caption" 
                sx={{ 
                  fontSize: '12px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  textAlign: 'center'
                }}
              >
                {selectedImage.name}
              </Typography>
            </CardActions>
          </ImageCard>
        </ImagePreviewContainer>
      )}
      {selectedImage && (
        <input
          style={{ display: 'none' }}
          id="change-image-input"
          name="signatureImage"
          type="file"
          accept={uploadImageAllowedTypes}
          onChange={handleFileChange}
          ref={(input) => {
            if (input) {
              input.onclick = null; 
            }
          }}
        />
      )}
    </Fragment>
  );
};

export default CaseLogo;
